import { Component, h, Host, Prop, Element, State } from "@stencil/core";
import { getPlaceholderUrl } from "../../utils/getPlaceholderUrl";

/**
 * @slot (default) - insert the call-to-action/link
 */
@Component({
    tag: "ux-iws-teaser-product-tile",
    styleUrl: "teaser-product-tile.scss",
})
export class TeaserProductTile {
    @Element() element: HTMLUxIwsTeaserProductTileElement;
    /** Name of the associated product  */
    @Prop({ reflect: true }) productName: string;
    /** Description of the associated product  */
    @Prop({ reflect: true }) productDesc: string;
    /** Image url pointing to a quadratic product image */
    @Prop({ reflect: true }) productImageUrl: string = "";
    /** Text that is presented on a highlight flag */
    @Prop({ reflect: true }) eyecatcher?: string;
    /** optional: the text of the cta link, the component will set it by itself */
    @Prop({ reflect: true, mutable: true }) linkText: string;
    /** optional: the href of the cta link, the component will set it by itself */
    @Prop({ reflect: true, mutable: true }) linkUrl: string;

    /** Storage for the current overlay visibility status */
    @State() overlayVisibility: boolean = false;

    componentWillLoad() {
        const link = this.element.querySelector("a");
        if (link) {
            this.linkText = link.textContent;
            this.linkUrl = link.getAttribute("href");
        }
    }

    render() {
        const baseClass = "ux-iws-teaser-product-tile";
        const image =
            this.productImageUrl !== ""
                ? {
                      backgroundImage: `url('${this.productImageUrl}')`,
                  }
                : undefined;
        return (
            <Host class={baseClass}>
                <div
                    class={`${baseClass}__inner`}
                    onMouseEnter={() => (this.overlayVisibility = true)}
                    onMouseLeave={() => (this.overlayVisibility = false)}
                >
                    <div
                        class={`${baseClass}__logo-image`}
                        style={{
                            backgroundImage: `url('${getPlaceholderUrl(1, 1)}'`,
                        }}
                    />
                    <div class={`${baseClass}__image`} style={image} />
                    <div
                        class={{
                            [`${baseClass}-content`]: true,
                            [`${baseClass}__layer`]: true,
                            "is-visible": !this.overlayVisibility,
                        }}
                    >
                        <div class={`${baseClass}__title`}>
                            {this.productName}
                        </div>
                        {this.eyecatcher && (
                            <ux-eyecatcher>{this.eyecatcher}</ux-eyecatcher>
                        )}
                    </div>
                    <ux-iws-link-wrapper
                        class={{
                            [`${baseClass}-overlay`]: true,
                            [`${baseClass}__layer`]: true,
                            "is-visible": this.overlayVisibility,
                        }}
                    >
                        <div
                            class={`${baseClass}__layer ${baseClass}-overlay__bg`}
                        />
                        <div
                            class={`${baseClass}__layer ${baseClass}-overlay__content`}
                        >
                            <div class={`${baseClass}__title`}>
                                {this.productName}
                            </div>
                            <ux-text-lines-limit text-lines="4">
                                <div class={`ux-text ${baseClass}__desc`}>
                                    {this.productDesc}
                                </div>
                            </ux-text-lines-limit>
                            <span class={`${baseClass}__spacer`} />
                            <slot />
                        </div>
                    </ux-iws-link-wrapper>
                </div>
            </Host>
        );
    }
}
